export const Heading = {
  baseStyle: {
    size: "md",
  },
};
